import { render, staticRenderFns } from "./admin-dataemployee.vue?vue&type=template&id=ff701f76&"
import script from "./admin-dataemployee.vue?vue&type=script&lang=js&"
export * from "./admin-dataemployee.vue?vue&type=script&lang=js&"
import style0 from "./admin-dataemployee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports